import { useEffect, useState } from 'react';
import { PageError } from '../../components/page/PageError';
import { config } from '../../config';
import { getRoute, useNavigate } from '../../routes';
import { useTitle } from '../../utils/useTitle';
import { LaunchZoomScreen } from './components/LaunchZoomScreen';
import { useRedirectFromOnDemand } from './hooks/useRedirectFromOnDemand';

export const ConnectNowJoinCallPage = (): JSX.Element => {
  useTitle(['Join Call', 'ConnectNow']);

  useRedirectFromOnDemand();

  const { zoomContactCenterApiKey, zoomContactCenterEntryId } = config;
  const ZOOM_CONTACT_CENTER_SDK_URL =
    'https://us01ccistatic.zoom.us/us01cci/web-sdk/video-client.js';

  const navigate = useNavigate();

  const [loadError, setLoadError] = useState(false);

  const initiateZoomVideoClient = async (): Promise<void> => {
    // @ts-expect-error - VideoClient is loaded into the window scope when the script is loaded.
    const videoClient = new VideoClient({ apikey: zoomContactCenterApiKey });
    await videoClient.init({
      entryId: zoomContactCenterEntryId,
    });

    void videoClient.startVideo();

    videoClient.on('video-force-end', () => {
      // TODO: navigate to connectNowHome page is not working at the moment
      navigate(getRoute('connectNowHome', {}));
    });
  };

  useEffect(() => {
    // Add the script tag containing Zoom Contact Center SDK to the page
    const script = document.createElement('script');
    script.src = ZOOM_CONTACT_CENTER_SDK_URL;

    document.body.appendChild(script);

    script.onload = () => {
      void initiateZoomVideoClient();
      setLoadError(false);
    };

    script.onerror = () => {
      document.body.removeChild(script);
      setLoadError(true);
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (loadError) {
    return <PageError goBackTo={getRoute('home', {})} />;
  }

  return <LaunchZoomScreen />;
};
